import {
  configureStore,
  combineReducers,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import auth from "./auth";
import app from "./app";

const persistConfig = {
  key: "root",
  storage,
  timeout: 0,
};

const authPersistConfig = {
  key: "auth",
  storage: storage,
  whitelist: ["token"],
};
const appPersistConfig = {
  key: "app",
  storage: storage,
  whitelist: ["initials", "rowsPerPage"],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, auth),
  app: persistReducer(appPersistConfig, app),
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
});
export const persistor = persistStore(store, {});
